import type { IContinueWatchProgressBar } from './ContinueWatchProgressBar.h'

import { ProgressBar } from 'atoms/ProgressBar'
import { TextBoxMaxLine1Caption4 } from 'atoms/TextBox/Templates'
import {
  WrapperAlignItems,
  WrapperBlock,
  WrapperDisplay,
  WrapperJustifyContent,
} from 'atoms/WrapperBlock'
import { COLOR } from 'vars/color'
import { ContinueWatchProgressBarSC } from './ContinueWatchProgressBar.styled'

export const ContinueWatchProgressBar = ({
  progress,
  color = COLOR.ACCENT_SECONDARY,
  timeTitle,
  description,
  ...rest
}: IContinueWatchProgressBar) => {
  return (
    <ContinueWatchProgressBarSC {...rest}>
      <WrapperBlock
        display={WrapperDisplay.FLEX}
        justifyContent={WrapperJustifyContent.SPACE_BETWEEN}
        alignItems={WrapperAlignItems.CENTER}
      >
        <TextBoxMaxLine1Caption4 title={description} />
        <TextBoxMaxLine1Caption4 title={timeTitle} />
      </WrapperBlock>
      <ProgressBar progress={progress} color={color} />
    </ContinueWatchProgressBarSC>
  )
}
